var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4,
    width: 12,
    height: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.00021C11.053 0.991238 9.61858 1.26963 8.27997 1.81924C6.94136 2.36886 5.72519 3.17876 4.70197 4.20197C3.67876 5.22519 2.86886 6.44136 2.31924 7.77997C1.76963 9.11858 1.49124 10.553 1.50021 12C1.49124 13.447 1.76963 14.8814 2.31924 16.22C2.86886 17.5586 3.67876 18.7748 4.70197 19.798C5.72519 20.8212 6.94136 21.6311 8.27997 22.1808C9.61858 22.7304 11.053 23.0088 12.5 22.9998C13.947 23.0088 15.3814 22.7304 16.72 22.1808C18.0586 21.6311 19.2748 20.8212 20.298 19.798C21.3212 18.7748 22.1311 17.5586 22.6808 16.22C23.2304 14.8814 23.5088 13.447 23.4998 12C23.5088 10.553 23.2304 9.11858 22.6808 7.77997C22.1311 6.44136 21.3212 5.22519 20.298 4.20197C19.2748 3.17876 18.0586 2.36886 16.72 1.81924C15.3814 1.26963 13.947 0.991238 12.5 1.00021ZM16.7781 17.4999L7.00011 7.72242L8.22242 6.50011L17.9999 16.278L16.7781 17.4999Z",
    fill: "#DA1E28"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError);
export default __webpack_public_path__ + "static/media/ic-error.05c696e607b48a7602f644d72b7629b8.svg";
export { ForwardRef as ReactComponent };